module.exports = __webpack_public_path__ + "static/img/024_TO8_1492_og.09e424a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/024_TO8_1492_og.jpg
// module id = W9V1
// module chunks = 0